import { Injectable } from '@angular/core';
import { WarehouseServiceProxy } from '@shared/service-proxies/service-proxies';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

export interface WarehouseTimeZoneInfo {
    warehouseId: number;
    timeZone: string | undefined;
}

@Injectable()
export class WarehouseTimeZoneService {

    readonly timeZones$: Observable<WarehouseTimeZoneInfo[]>;

    constructor(warehouseService: WarehouseServiceProxy) {
        this.timeZones$ = warehouseService.getAll().pipe(
            map(({ items }) => items.map(item => ({ warehouseId: item.id, timeZone: item.timeZone }))),
            shareReplay({ refCount: false, bufferSize: 1 }),
        );
    }

    getTimeZone$(warehouseId: number) {
        return this.timeZones$.pipe(map(items => items.find(x => x.warehouseId === warehouseId)?.timeZone));
    }
}
